import { BiBlock, BiLineChart, BiListUl, BiShield } from "react-icons/bi";
import { Link } from "react-router-dom";
import { CheckPermission } from "../Permissions/PermissionManager";
import ScpPermissions from "../Permissions/Data/ScpPermissions";
import { GetCurrentUser } from "../Authorization/AuthorizationManager";

const ServerTypes = [
    { 
        Id: 0, 
        Name: "SCP: Secret Laboratory",
        DropDownButtons: (server) => {
            const user = GetCurrentUser();

            const checkDisabled = () => {
                if(!server.isActive)
                    return "serverDropdownLinkDisabled";

                return "";
            }

            return (
                <>
                    <Link className={`center-x serverDropdownBtn ${checkDisabled()}`} to={`/scpsl-ra/${server.id}`}>
                        <BiShield className="subpageIcon"/>
                        Remote Admin
                    </Link>
                    <Link className="center-x serverDropdownBtn" to={`/scpsl-logs/${server.id}`}>
                        <BiListUl className="subpageIcon"/> 
                        Logs
                    </Link>
                    { CheckPermission(server.permissions, user.Permissions, [ScpPermissions.SCP_Ban, ScpPermissions.SCP_Kick, ScpPermissions.SCP_Mutes], true) &&
                        <Link className={`center-x serverDropdownBtn ${checkDisabled()}`} to={`/scpsl-punishments/${server.id}`}>
                            <BiBlock className="subpageIcon"/>
                            Punishments
                        </Link>
                    }

                    <Link className="center-x serverDropdownBtn serverDropdownLinkDisabled" to={`/scpsl-statistics/${server.id}`}>
                        <BiLineChart className="subpageIcon"/>
                        Statistics
                    </Link>            
                </>
            )
        }
    },
    { 
        Id: 1, 
        Name: "Unturned",
        DropDownButtons: [
            
        ]
    }
];

export default ServerTypes;